import { watch } from 'vue'
import { useWindowSize } from '@vueuse/core'

export default () => {
  const setVh = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
  const { width } = useWindowSize()
  watch(width, setVh, { immediate: true })

  return {}
}
